import { Maximize, Maximize2 } from 'lucide-react';
import { useMemo } from 'react';

import { Flex } from '@/components/base';
import IconButton from '@/components/Button/IconButton';
import Tooltip from '@/components/Tooltip/TooltipV2';
import useKeymap from '@/hooks/pure/useKeymap';
import useDetailModalStore from '@/stores/pure/DetailModalStore';
import useUIStore from '@/stores/pure/UIStore';

export const FeedbackViewSizeToggleActions = () => {
  const modalStack = useDetailModalStore((state) => state.modalStack);
  const state = useUIStore((state) => ({
    toggleFeedbackDetailFullView: state.toggleFeedbackDetailFullView,
    feedbackDetailFullView: state.feedbackDetailFullView,
  }));
  const feedbackDetailFullView = useMemo(() => {
    return modalStack.length > 1 ? false : state.feedbackDetailFullView;
  }, [modalStack.length, state.feedbackDetailFullView]);

  useKeymap('KeyZ', state.toggleFeedbackDetailFullView);
  return (
    <Flex a="center">
      <Tooltip
        tooltipNode={
          state.feedbackDetailFullView ? 'Shrink View' : 'Expand View'
        }
        shortcut="Z"
      >
        <IconButton
          onClick={state.toggleFeedbackDetailFullView}
          icon={
            feedbackDetailFullView ? (
              <Maximize size={12} />
            ) : (
              <Maximize2 size={12} />
            )
          }
        />
      </Tooltip>
    </Flex>
  );
};
